import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { type BookabilityStatusItem } from "../types";
import { useBookabilityStatus } from "./useBookabilityStatus";

interface BookabilityStatusProps {
  shiftIds: string[];
  agentId: string;
}
export function useGetBookabilityStatusForShifts(props: BookabilityStatusProps) {
  const { shiftIds, agentId } = props;

  const isSingleSourceOfBookabilityEnabled = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_BOOKABILITY_STATUS_CHECK,
    { defaultValue: false }
  );

  const bookabilityStatusQueryResult = useBookabilityStatus(
    {
      workerId: agentId,
      shiftIds,
      returnFirstUnmetCriteria: true,
    },
    {
      enabled: isDefined(agentId) && shiftIds.length > 0 && isSingleSourceOfBookabilityEnabled,
    }
  );

  const { data: shiftBookabilityData, isSuccess: shiftBookabilitySuccess } =
    bookabilityStatusQueryResult;

  const shiftBookability = shiftBookabilitySuccess ? shiftBookabilityData.data : [];

  return {
    shiftBookabilityById: shiftBookability.reduce<Record<string, BookabilityStatusItem>>(
      (shiftBookabilityAccumulator, item) => {
        const shiftId = item.id;
        return { ...shiftBookabilityAccumulator, [shiftId]: item };
      },
      {}
    ),
    isSingleSourceOfBookabilityEnabled,
    queryResult: bookabilityStatusQueryResult,
  };
}
